import GlobalStyle from "./styles/global";
import styled from "styled-components";
import RegisterUserForm from "./pages/RegisterUserForm";
import React, { useState } from "react";
import { PicklistProvider } from "./contexts/PicklistProvider";


function Start() {
	const [onEdit, setOnEdit] = useState(null);

	return (
		<div className="user-form-app container">
			<PicklistProvider>
				<GlobalStyle />
				<RegisterUserForm onEdit={onEdit} setOnEdit={setOnEdit} />
			</PicklistProvider>
		</div>
	);
}

export default Start;